const AlocacaoCargaSituacaoEnum = {
    ABERTO: 1,
    CROSSDOCKING: 2,
    ENTREGA_CLIENTE: 3,
    FINALIZADO: 4,
    VEICULO_ALOCADO: 5
}

export default AlocacaoCargaSituacaoEnum;